<template>
  <div style="height:100%">
    <transition name="mainvisual">
      <div id="mainvisual" v-if="mainvisual">
        <div id="tcc"><img src="/img/logo_tcc_mv.png" alt="東京カメラ部"></div>
        <h1><span><img src="/img/h1.png" alt="日本は発見を待っている。"></span></h1>
      </div>
    </transition><!-- /#mainvisual -->

    <transition name="maincontent">
      <div class="mainContent" v-show="mainContent">
        <div class="wrapper">
          <header>
            <h1>
              <picture>
                <source media="(max-width:960px)" srcset="/img/logo_title_sp.png"/>
                <img src="/img/logo_title.png" srcset="/img/logo_title@2x.png 2x" alt="東京カメラ部 日本写真100景 ～日本は発見を待っている。～">
              </picture>
            </h1>
          </header>

          <div id="mapArea">
            <div id="mapViewPhotos" class="fade" @click="openModalThumbnailList()">
              <img src="/img/blank.gif" alt="View Photos">
            </div><!-- /mapViewPhotos -->
            <div id="mapViewVideos" class="fade" @click="openModalVideo()">
              <img src="/img/blank.gif" alt="View Videos">
            </div><!-- /mapViewVideos -->
            <div id="mapMenu">
              <div id="menuAll" :class="allON"><img src="/img/blank.gif" alt="全ての季節" @click="changeSeason(EnumSeasonAll)"></div>
              <div id="menuSpring" :class="springON"><img src="/img/blank.gif" alt="春 spring" @click="changeSeason(EnumSeasonSpring)"></div>
              <div id="menuSummer" :class="summerON"><img src="/img/blank.gif" alt="夏 summer" @click="changeSeason(  EnumSeasonSummer)"></div>
              <div id="menuAutumn" :class="autumnON"><img src="/img/blank.gif" alt="秋 autumn" @click="changeSeason(EnumSeasonAutumn)"></div>
              <div id="menuWinter" :class="winterON"><img src="/img/blank.gif" alt="冬 winter" @click="changeSeason(EnumSeasonWinter)"></div>
            </div><!-- /mapMenu -->
            <div id="gMapArea">
              <GmapMap
                :center="center"
                :zoom="zoom"
                :options="options"
                ref="map"
                style="width: 100%; height: 100%; position: absolute;"
              >
                <GmapCluster
                    :gridSize="36"
                    :zoomOnClick="true"
                    :minimumClusterSize="2"
                    :styles="clusterStyles"
                    ref="cluster"
                >
                  <GmapMarker
                    v-for="(marker, index) in markers"
                    :key="index"
                    :position="marker.position"
                    :clickable="true"
                    :draggable="false"
                    :icon="marker.icon"
                    @mouseover="marker.openInfoWindow=true"
                    @mouseout="marker.openInfoWindow=false"
                    @click="openModal(marker.work)"
                  >
                    <GmapInfoWindow
                      :options="{maxWidth: 300, disableAutoPan: true}"
                      :opened="marker.openInfoWindow"
                    >
                      <img :src="marker.imageUrl" style="maxWidth: 200px; margin-left:2px">
                    </GmapInfoWindow>
                  </GmapMarker>
                </GmapCluster>
              </GmapMap>
            </div><!-- /gMapArea -->
          </div><!-- /mapArea-->
        </div><!-- /wrapper -->

        <footer>
          <div class="about">
            <p class="fade" @click="openModalAbout()">日本写真100景とは？</p>
          </div><!-- /about -->

          <div class="copyright">
            <a class="fade" target="_blank" href="https://localgov.tokyocameraclub.com/"><img src="/img/logo_tcc.png" srcset="/img/logo_tcc@2x.png 2x" alt="東京カメラ部" /></a>
            <p>Copyright &copy; <br>Tokyo Camera Club Corp. <br>All rights reserved.</p>
          </div><!-- /copyright -->
        </footer>
      </div>
    </transition><!-- /#maincontent -->

    <ModalAbout
      :open.sync="modalAbout"
    ></ModalAbout>

    <ModalPhoto
      :open.sync="modalPhoto"
      :work.sync="modalWork"
    ></ModalPhoto>

    <ModalVideo
      :open.sync="modalVideo"
    ></ModalVideo>

    <ModalThumbnailList
      :open.sync="modalThumbnailList"
      :works.sync="works"
      :season.sync="season"
      @change="changeSeason"
      @click="clickThumbnailWork"
    ></ModalThumbnailList>

  </div>
</template>

<script>
import { Me } from '@/api'
import { mapActions, mapGetters } from 'vuex'
import GmapCluster from 'vue2-google-maps/dist/components/cluster'
import ModalAbout from '@/views/ModalAbout.vue'
import ModalPhoto from '@/views/ModalPhoto.vue'
import ModalVideo from '@/views/ModalVideo.vue'
import ModalThumbnailList from '@/views/ModalThumbnailList.vue'
import enumMixin from '@/concern/enumMixin'

export default {
  mixins: [enumMixin], // Enum値の読み込み
  components: {
    GmapCluster,
    ModalAbout,
    ModalPhoto,
    ModalVideo,
    ModalThumbnailList
  },
  data () {
    return {
      // 作品
      works: [],
      season: null,
      // GoogleMap関連データ
      center: { lat: 43.5880947, lng: 142.4647807 },
      zoom: 4,
      options: {
        clickableIcons: false,
        zoomControl: false,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        disableDefaultUi: false,
        styles: [
          { featureType: 'landscape.natural', stylers: [{ color: '#FFFFFF' }] },
          { featureType: 'road', stylers: [{ gamma: 2.61 }, { color: '#e8e8e8' }] },
          { featureType: 'transit.line', stylers: [{ invert_lightness: true }, { visibility: 'simplified' }, { color: '#e8e8e8' }] },
          { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
          { elementType: 'labels.text.fill', stylers: [{ color: '#b7bdc7' }] },
          { featureType: 'landscape.man_made', elementType: 'geometry', stylers: [{ visibility: 'simplified' }, { color: '#FFFFFF' }] },
          { featureType: 'poi', elementType: 'geometry', stylers: [{ color: '#e8e8e8' }] },
          { featureType: 'water', stylers: [{ color: '#b7bdc7' }] },
          { featureType: 'transit.station', elementType: 'geometry', stylers: [{ color: '#e8e8e8' }] }
        ]
      },
      markers: [],
      infoWindow: {
        position: { lat: 0, lng: 0 },
        open: false
      },
      clusterStyles: [
        {
          textColor: 'white',
          url: '/img/googlemap/m1.png',
          height: 74,
          width: 72,
          anchorText: [0, 1]
        },
        {
          textColor: 'white',
          url: '/img/googlemap/m2.png',
          height: 77,
          width: 74,
          anchorText: [0, 1]
        },
        {
          textColor: 'white',
          url: '/img/googlemap/m3.png',
          height: 87,
          width: 84,
          anchorText: [0, 1]
        },
        {
          textColor: 'white',
          url: '/img/googlemap/m4.png',
          height: 99,
          width: 96,
          anchorText: [0, 1]
        },
        {
          textColor: 'white',
          url: '/img/googlemap/m5.png',
          height: 111,
          width: 109,
          anchorText: [0, 1]
        }
      ],
      // モーダル関連
      modalWork: null,
      modalPhoto: false,
      modalThumbnailList: false,
      modalAbout: false,
      modalVideo: false,
      // メインビジュアル切り替え用
      showMainVisual: false,
      mainvisual: false,
      mainContent: false
    }
  },
  async created () {
    const showMvDate = this.$cookies.get('_show_mv_date')
    if (!showMvDate && !this.$route.query.id) {
      this.showMainVisual = true
      this.$cookies.set('_show_mv_date', true)
      this.$ga.event('Opening', 'show', null, null)
    }
    // this.showMainVisual = true // TODO:一時的に常に表示
    // APIデータの取得
    await Me.getUserWorks()
      .then(async response => {
        // 国名はいらないので「日本、」という文字列を削除
        for (const work of response.data) work.address = work.address.replace('日本、', '')
        // 変数に格納
        this.initWorks(response.data)
      }).catch(() => {
      })
    this.season = this.EnumSeasonAll
    this.works = this.allWorks
    if (!this.showMainVisual || this.$route.query.id) this.showMap()

    // 初期画面遷移の決定
    if (this.$route.path.includes('/about')) { // aboutが指定されていた場合は開く
      this.openModalAbout()
    } else if (this.$route.path.includes('/list')) { // listが指定されていた場合は開く
      this.openModalThumbnailList()
    } else if (this.$route.path.includes('/video')) { // videoが指定されていた場合は開く
      this.openModalVideo()
    } else if (this.$route.params.id) { // 画像が指定されていた場合は開く
      for (const work of this.allWorks) {
        if (parseInt(work.id) === parseInt(this.$route.params.id)) {
          this.openModalByTymbnail(work)
          break
        }
      }
    }
  },
  mounted () {
    if (this.showMainVisual && !this.$route.query.id) {
      this.mainvisual = true
      setTimeout(() => {
        this.showMap()
      }, 5000)
    }
  },
  computed: {
    ...mapGetters([
      'allWorks', 'springWorks', 'summerWorks', 'autumnWorks', 'winterWorks'
    ]),
    allON () {
      return this.season === this.EnumSeasonAll ? 'on' : 'fade'
    },
    springON () {
      return this.season === this.EnumSeasonSpring ? 'on' : 'fade'
    },
    summerON () {
      return this.season === this.EnumSeasonSummer ? 'on' : 'fade'
    },
    autumnON () {
      return this.season === this.EnumSeasonAutumn ? 'on' : 'fade'
    },
    winterON () {
      return this.season === this.EnumSeasonWinter ? 'on' : 'fade'
    }
  },
  methods: {
    ...mapActions([
      'updateAllWorks', 'updateSpringWorks', 'updateSummerWorks', 'updateAutumnWorks', 'updateWinterWorks'
    ]),
    async showMap () {
      this.mainContent = true
      this.mainvisual = false
      await this.setMarker(this.works)
      if (this.showMainVisual && !this.$route.query.id) this.modalAbout = true
      if (this.$route.query.id) {
        let modalWork = null
        for (const work of this.works) if (work.id === Number(this.$route.query.id)) modalWork = work
        if (modalWork) {
          setTimeout(() => {
            this.zoom = 10
            this.openModalByTymbnail(modalWork)
          }, 1500)
        }
      }
    },
    initWorks (works) {
      works.sort(function (a, b) {
        if (a.latitude > b.latitude) {
          return -1
        } else {
          return 1
        }
      })
      const springWorks = []
      const summerWorks = []
      const autumnWorks = []
      const winterWorks = []
      for (const work of works) {
        const date = new Date(work.takenAt)
        const month = date.getMonth() + 1
        if ([3, 4, 5].includes(month)) springWorks.push(work)
        if ([6, 7, 8].includes(month)) summerWorks.push(work)
        if ([9, 10, 11].includes(month)) autumnWorks.push(work)
        if ([12, 1, 2].includes(month)) winterWorks.push(work)
      }
      this.updateAllWorks(works)
      this.updateSpringWorks(springWorks)
      this.updateSummerWorks(summerWorks)
      this.updateAutumnWorks(autumnWorks)
      this.updateWinterWorks(winterWorks)
    },
    async setMarker (works, fit = true) {
      // markerの初期化
      this.markers.splice(0)
      if (!works || works.length === 0) return false
      for (const work of works) {
        this.markers.push({
          position: { lat: parseFloat(work.latitude), lng: parseFloat(work.longitude) },
          work: work,
          openInfoWindow: false,
          imageUrl: work.thumbnailUrl,
          icon: { url: '/img/icon_photo_s.png' }
        })
      }
      if (fit) {
        // 中心・倍率・表示範囲の計算
        let minX = this.markers[0].position.lng
        let maxX = this.markers[0].position.lng
        let minY = this.markers[0].position.lat
        let maxY = this.markers[0].position.lat
        for (const marker of this.markers) {
          if (marker.work.country !== '日本') continue
          if (marker.position.lng <= minX) { minX = marker.position.lng }
          if (marker.position.lng > maxX) { maxX = marker.position.lng }
          if (marker.position.lat <= minY) { minY = marker.position.lat }
          if (marker.position.lat > maxY) { maxY = marker.position.lat }
        }
        this.$gmapApiPromiseLazy().then(async () => {
          const sw = new window.google.maps.LatLng(maxY, minX)
          const ne = new window.google.maps.LatLng(minY, maxX)
          const bounds = new window.google.maps.LatLngBounds(sw, ne)
          const map = await this.$refs.map.$mapPromise
          map.fitBounds(bounds)
        })
      }
    },
    changeSeason (season) {
      this.season = season
      if (this.season === this.EnumSeasonAll) this.works = this.allWorks
      if (this.season === this.EnumSeasonSpring) this.works = this.springWorks
      if (this.season === this.EnumSeasonSummer) this.works = this.summerWorks
      if (this.season === this.EnumSeasonAutumn) this.works = this.autumnWorks
      if (this.season === this.EnumSeasonWinter) this.works = this.winterWorks
      this.setMarker(this.works, false)

      let seasonText = ''
      if (season === this.EnumSeasonAll) seasonText = 'all'
      if (season === this.EnumSeasonSpring) seasonText = 'spring'
      if (season === this.EnumSeasonSummer) seasonText = 'summer'
      if (season === this.EnumSeasonAutumn) seasonText = 'autumn'
      if (season === this.EnumSeasonWinter) seasonText = 'winter'
      this.$ga.event('Top Change Season', 'click', seasonText, null)
    },
    openModal (work) {
      setTimeout(() => {
        this.modalWork = work
        this.modalPhoto = true
        // 個別画像ページへURL書き換え
        const path = `/images/${work.id}`
        if (path !== this.$route.path) {
          this.$router.push(path)
        }
        const title = `${work && work.prefectures && work.prefectures}${work && work.city && work.city}の写真 - 東京カメラ部 日本写真100景 ～日本は発見を待っている。～`
        document.title = title // タイトル書き換え
        let award = ''
        if (work.spotInformations && work.spotInformations.awardType) award = `[${work.spotInformations.awardType}]`
        const description = `${work.address}の写真 撮影: ${work.photographer}${award} 緯度経度: ${work.latitude},${work.longitude}`
        const ogTitle = document.querySelector('meta[property="og:title"]')
        const metaDescription = document.querySelector('meta[name="description"]')
        const ogDescription = document.querySelector('meta[property="og:description"]')
        const ogImage = document.querySelector('meta[property="og:image"]')
        const ogUrl = document.querySelector('meta[property="og:url"]')
        if (ogTitle) ogTitle.setAttribute('content', title)
        if (metaDescription) metaDescription.setAttribute('content', description)
        if (ogDescription) ogDescription.setAttribute('content', description)
        if (ogImage) ogImage.setAttribute('content', work.thumbnailUrl)
        setTimeout(() => {
          if (ogUrl) ogUrl.setAttribute('content', location.href)
        }, 200)
      }, 200)
      this.$ga.event('Top Spot Icon', 'click', `work_${work.id}`, null)
    },
    openModalByTymbnail (work) {
      this.$gmapApiPromiseLazy().then(async () => {
        const map = await this.$refs.map.$mapPromise
        map.panTo(new window.google.maps.LatLng(work.latitude, work.longitude))
        this.modalWork = work
        this.modalPhoto = true
        const path = `/images/${work.id}`
        if (path !== this.$route.path) {
          this.$router.push(path)
        }
        const title = `${work && work.prefectures && work.prefectures}${work && work.city && work.city}の写真 - 東京カメラ部 日本写真100景 ～日本は発見を待っている。～`
        document.title = title // タイトル書き換え
        let award = ''
        if (work.spotInformations && work.spotInformations.awardType) award = `[${work.spotInformations.awardType}]`
        const description = `${work.address}の写真 撮影: ${work.photographer}${award} 緯度経度: ${work.latitude},${work.longitude}`
        const ogTitle = document.querySelector('meta[property="og:title"]')
        const metaDescription = document.querySelector('meta[name="description"]')
        const ogDescription = document.querySelector('meta[property="og:description"]')
        const ogImage = document.querySelector('meta[property="og:image"]')
        const ogUrl = document.querySelector('meta[property="og:url"]')
        if (ogTitle) ogTitle.setAttribute('content', title)
        if (metaDescription) metaDescription.setAttribute('content', description)
        if (ogDescription) ogDescription.setAttribute('content', description)
        if (ogImage) ogImage.setAttribute('content', work.thumbnailUrl)
        setTimeout(() => {
          if (ogUrl) ogUrl.setAttribute('content', location.href)
        }, 200)
      })
    },
    clickThumbnailWork (work) {
      this.zoom = 10
      setTimeout(() => {
        this.openModalByTymbnail(work)
      }, 700)
    },
    openModalThumbnailList () {
      this.$ga.event('Top View Photos', 'click', null, null)
      this.modalThumbnailList = true
      const path = '/list'
      if (path !== this.$route.path) {
        this.$router.push(path)
      }
      document.title = '季節の写真一覧 - 東京カメラ部 日本写真100景 ～日本は発見を待っている。～' // タイトル書き換え
    },
    openModalAbout () {
      this.$ga.event('About', 'click', null, null)
      this.modalAbout = true
      const path = '/about'
      if (path !== this.$route.path) {
        this.$router.push(path)
      }
      document.title = '日本写真100景とは - 東京カメラ部 日本写真100景 ～日本は発見を待っている。～' // タイトル書き換え
    },
    openModalVideo () {
      this.$ga.event('Videos', 'click', null, null)
      this.modalVideo = true
      const path = '/video'
      if (path !== this.$route.path) {
        this.$router.push(path)
      }
      document.title = '日本写真100景を動画で - 東京カメラ部 日本写真100景 ～日本は発見を待っている。～' // タイトル書き換え
    }
  }
}
</script>

<style>
.vue-map-container {
  height: 100% !important;
  z-index: 0 !important;
}
.gm-ui-hover-effect {
  display: none !important;
}
body::-webkit-scrollbar {
  display: none !important;
  -webkit-appearance: none !important;
}
.vm--container::-webkit-scrollbar {
  display: none !important;
  -webkit-appearance: none !important;
}
.vm--container.scrollable .vm--modal {
  margin-bottom: 0px !important;
}

.mainvisual-enter-active, .mainvisual-leave-actibe {
  transition: opacity 5s;
}
.mainvisual-enter, .mainvisual-leave-to {
  opacity: 0;
  transition: opacity 2.5s;
}

.maincontent-enter-active, .maincontent-leave-actibe {
  transition: opacity 2s;
}
.maincontent-enter, .maincontent-leave-to {
  opacity: 0;
  transition: opacity 1.0s;
}
</style>
